






















import Vue, { PropType } from "vue";
import { SharedLink, Manuscript, User } from "@/lib/models";
import { Comment as CommentDexie } from "@/lib/indexeddb";
import DotIcon from "@/components/atoms/DotIcon.vue";

export default Vue.extend<{}, Methods, Computed, Props>({
  components: { DotIcon },
  props: {
    novelId: {
      type: String as PropType<string>,
    },
  },
  methods: {
    async select(manuscriptKey) {
      this.$store.dispatch("sharedLinkModule/selectManuscript", manuscriptKey);
    },
    back() {
      this.$store.dispatch("sharedLinkModule/initializeSelectedSharedLink");
    },
  },
  computed: {
    user() {
      return this.$store.getters["userModule/user"] as User;
    },
    selectedSharedLinkId() {
      return this.$store.getters["sharedLinkModule/selectedSharedLinkId"];
    },
    sharedLinkName() {
      const sharedLinkList = this.$store.getters["sharedLinkModule/sharedLinkList"] as SharedLink[];
      const sharedLink = sharedLinkList.find((sharedLink) => sharedLink.sharedLinkId === this.selectedSharedLinkId);
      return sharedLink!.name || "NO TITLE";
    },
    manuscriptList() {
      const sharedLinkList = this.$store.getters["sharedLinkModule/sharedLinkList"] as SharedLink[];
      const sharedLink: SharedLink = sharedLinkList.find(
        (sharedLink) => sharedLink.sharedLinkId === this.selectedSharedLinkId
      )!;
      const manuscriptList = this.$store.getters["manuscriptModule/manuscriptList"] as Manuscript[];
      return manuscriptList.filter((manuscript) => sharedLink.manuscriptKeys!.includes(manuscript.key!));
    },
    isIncludesUnreadComment() {
      return (manuscriptKey) => {
        const { novelId } = this;
        const { userId } = this.user as User;
        const sharedLinkId = this.selectedSharedLinkId;
        const unreadCommentList = this.$store.getters["sharedLinkModule/unreadCommentList"](
          userId,
          novelId,
          sharedLinkId,
          manuscriptKey
        ) as CommentDexie[];
        return !!unreadCommentList.length;
      };
    },
  },
});

interface Props {
  novelId: string;
}

interface Methods {
  select: (sharedLinkId: string) => void;
  back: () => void;
}

interface Computed {
  user: User;
  selectedSharedLinkId: string;
  sharedLinkName: string;
  manuscriptList: Manuscript[];
  isIncludesUnreadComment: (manuscriptKey: string) => boolean;
}
